import { getInstanceByDom } from 'echarts';
import html2canvas from 'html2canvas';

const nextFrame = () => new Promise<void>(resolve => {
  requestAnimationFrame(() => resolve());
});

export async function captureAccessOverview(element: HTMLDivElement): Promise<HTMLCanvasElement> {
  await element.ownerDocument.fonts.ready;
  // Let responsive layout and its ResizeObserver updates reach the chart components.
  await nextFrame();
  await nextFrame();

  element.querySelectorAll<HTMLDivElement>('.echarts-for-react').forEach(chartElement => {
    const chart = getInstanceByDom(chartElement);
    if (!chart || chart.isDisposed()) return;

    // The wrapper's delayed resize can otherwise leave an old canvas in a larger card.
    chart.resize({
      width: chartElement.clientWidth,
      height: chartElement.clientHeight,
      animation: { duration: 0 },
      silent: true,
    });
    chart.getZr().flush();
  });
  await nextFrame();

  const { width, height } = element.getBoundingClientRect();
  return html2canvas(element, {
    scale: 2,
    width: Math.ceil(width),
    height: Math.ceil(height),
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    backgroundColor: '#ffffff',
    useCORS: true,
    logging: false,
    onclone: (_document, clonedElement) => {
      // Preserve the measured capture size instead of recalculating its available space.
      clonedElement.style.width = `${width}px`;
      clonedElement.style.height = `${height}px`;
      clonedElement.style.flex = 'none';
    },
  });
}
